import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ProductRecommendationSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ProductRecommendationSVG;
